module.exports = __webpack_public_path__ + "img/act-of-emotion-1.229a31df.jpg";